import _isEqual from 'lodash/isEqual'
import { memo } from 'react'
import { z } from 'zod'

import UiKitInformationList from '@nxt-insurance/ui-kit/components/listComponents/InformationList'

import { iconSchema } from '@/cms/helperTypes'
import { Icon } from '@/components/Icon'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const informationList = z.object({
  _key: z.string(),
  _type: z.literal('informationList'),
  items: z
    .array(
      z.object({
        _key: z.string(),
        title: z.string(),
        description: z.string().optional(),
        icon: iconSchema,
      })
    )
    .optional(),
})

export const InformationList = memo((props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = informationList.parse(props.node.value)
  const { items } = value
  if (!items) {
    return null
  }
  const informationListItems = items.map((item) => ({
    id: item._key,
    title: item.title,
    description: item.description ?? '',
    icon: <Icon size="large" icon={item.icon} />,
  }))
  return <UiKitInformationList listData={informationListItems} />
}, _isEqual)
